import React, { Component } from 'react';
import { Table } from "react-bootstrap";

class EstudiantesList extends Component {

    abrirHistorico = (id) => (e) => {
        this.props.funcion(id)
    }

    regulares = () => {
        let { regulares } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        if (regulares.length === 0) return (
            <tr>
                <td colSpan={4} align="center">La búsqueda no obtuvo resultados</td>
            </tr>
        )

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        return (
            regulares.map(option => (
                <tr key={option.id_estudiante}>
                    <td style={styles}>{`${option.nacionalidad} ${option.ci}`}</td>
                    <td style={styles}>{nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)}</td>
                    <td align="center" style={styles}>{option.carrera_name}</td>
                    <td align="center" style={styles}>
                        <button onClick={this.abrirHistorico(
                            {
                                id: option.id_estudiante,
                                ci: `${option.nacionalidad} ${option.ci}`,
                                nombre: nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)
                            }
                        )} style={{borderWidth: 1}} className="btn btn-primary"><i className="fa fa-gear"></i> Ver Histórico</button> 
                    </td>
                </tr>
            ))
        )
    }

    noInscritos = () => {
        let { noInscritos } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        if (noInscritos.length === 0) return (
            <tr>
                <td colSpan={4} align="center">La búsqueda no obtuvo resultados</td>
            </tr>
        )

        return (
            noInscritos.map(option => (
                <tr key={option.id_estudiante}>
                    <td style={styles}>{`${option.nacionalidad} ${option.ci}`}</td>
                    <td style={styles}>{nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)}</td>
                    <td align="center" style={styles}>{option.carrera_name}</td>
                    <td align="center" style={styles}>
                        <button onClick={this.abrirHistorico(
                            {
                                id: option.id_estudiante,
                                ci: `${option.nacionalidad} ${option.ci}`,
                                nombre: nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)
                            }
                        )} style={{borderWidth: 1}} className="btn btn-primary"><i className="fa fa-gear"></i> Ver Histórico</button> 
                    </td>
                </tr>
            ))
        )

    }

    egresados = () => {
        let { egresados } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        if (egresados.length === 0) return (
            <tr>
                <td colSpan={4} align="center">La búsqueda no obtuvo resultados</td>
            </tr>
        )

        return (
            egresados.map(option => (
                <tr key={option.id_est}>
                    <td align="center" style={styles}>{`${option.nacionalidad} ${option.ci}`}</td>
                    <td style={styles}>{nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)}</td>
                    <td align="center" style={styles}>{option.carrera_name}</td>
                    <td align="center" style={styles}>
                        <button onClick={this.abrirHistorico(
                            {
                                id: option.id_est,
                                ci: `${option.nacionalidad} ${option.ci}`,
                                nombre: nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)
                            }
                        )} style={{borderWidth: 1}} className="btn btn-primary"><i className="fa fa-gear"></i> Ver Histórico</button> 
                    </td>
                </tr>
            ))
        )
    }

    render() {
        let { regulares, egresados, noInscritos } = this.props;
        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <div className="custom-mt-10">
                <div className="text-danger">Estudiantes Regulares ({regulares.length}):</div>
                <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {this.regulares()}
                        </tbody>
                    </Table>
                </div>
                <div className="text-danger custom-mt-10">Estudiantes No Inscritos ({noInscritos.length}):</div>
                <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {this.noInscritos()}
                        </tbody>
                    </Table>
                </div>
                <div className="text-danger custom-mt-10">Estudiantes Egresados y/o Retirados ({egresados.length}):</div>
                <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {this.egresados()}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}
 
export default EstudiantesList;


// WEBPACK FOOTER //
// ./src/views/Registros/HistoricoContent/EstudiantesList.jsx